import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: '01', label: 'USkills Trades Academy (UCOL)' },
    { value: '02', label: 'Ara Trades Academy (Ara)' },
    {
      value: '03',
      label: 'Otago Secondary-Tertiary College (Otago Polytechnic)',
    },
    {
      value: '04',
      label: 'Bay of Plenty Futures Academy (Trident High School)',
    },
    {
      value: '05',
      label: 'Hawke’s Bay and Tairāwhiti School’s Trades Academy (EIT)',
    },
    {
      value: '06',
      label: 'Te Arataki Ki Te Uru Trades Academy (Kelston Girls College)',
    },
    {
      value: '07',
      label: 'Land Based Trades Academy (National Trades Academy Ltd)',
    },
    {
      value: '08',
      label: 'Manurewa High School Trades Academy (Manurewa High School)',
    },
    { value: '09', label: 'Top of the South Trades Academy (Nayland College)' },
    {
      value: '10',
      label:
        'New Zealand Primary Industries Trades Academy (Food and Fibre Industry Skills Board - Primary ITO)',
    },
    {
      value: '12',
      label: 'Southern Cross Trades Academy (Southern Cross Campus)',
    },
    {
      value: '13',
      label: 'Te Taitokerau Trades Academy (Tikipunga High School)',
    },
    { value: '14', label: 'Tāmaki College Trades Academy (Tāmaki College)' },
    { value: '15', label: 'Taranaki Trades Academy (WITT)' },
    {
      value: '16',
      label: 'Taumarunui High School Trades Academy (Taumarunui High School)',
    },
    { value: '17', label: 'Huarahi Trades Academy (Te Aho o Te Kura Pounamu)' },
    { value: '18', label: 'Waikato Trades Academy (Wintec)' },
    { value: '19', label: 'Wellington Trades Academy (Whitireia and WelTec)' },
    {
      value: '20',
      label: 'Auckland West Vocational Academy (Massey High School)',
    },
    { value: '21', label: 'West Coast Trades Academy (Greymouth High School)' },
    { value: '22', label: 'MIT School of Secondary-Tertiary Studies (MIT)' },
    { value: '23', label: 'MIT Trades Academy (MIT)' },
    { value: '24', label: 'Murihiku Tertiary Academy (SIT)' },
    {
      value: '25',
      label: 'Aotearoa Trades Academy (Te Wānanga o Aotearoa)',
    },
    { value: '99', label: 'Other' },
  ],
});
